export function shouldClearStagedSubmissionAfterAcceptedTurnStart(
  _replaysPriorSubmission: boolean,
): boolean {
  return false;
}
